var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("modal", {
    attrs: {
      variant: "default",
      "custom-class": "add-to-calendar",
      "no-footer": "",
      "aria-labelled-by": "modify-calendar-modal-title",
    },
    on: { close: _vm.handleCloseModal },
    scopedSlots: _vm._u(
      [
        {
          key: "default",
          fn: function (ref) {
            var activate = ref.activate
            return [_vm._t("default", null, null, { activate: activate })]
          },
        },
        {
          key: "body",
          fn: function (ref) {
            var deactivate = ref.deactivate
            return [
              _vm.loading
                ? _c(
                    "div",
                    { staticClass: "modal-loading" },
                    [_c("loading-dots")],
                    1
                  )
                : _vm._e(),
              _vm._v(" "),
              _c(
                "div",
                {
                  staticClass: "modal-title",
                  attrs: { id: "modify-calendar-modal-title" },
                },
                [
                  _vm._v(
                    "\n      " +
                      _vm._s(_vm.ModifyReservationCalendarTitle) +
                      "\n    "
                  ),
                ]
              ),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "add-to-calendar-carousel" },
                [
                  _vm._l(
                    _vm.currentReservationData.reservations.filter(function (
                      item
                    ) {
                      return item.status !== "Cancelled"
                    }),
                    function (item, index) {
                      return _c(
                        "div",
                        {
                          key: index,
                          staticClass: "add-to-calendar-carousel__item",
                        },
                        [
                          _vm.selectedRes.id === item.id && !_vm.loadingRooms
                            ? _c(
                                "div",
                                {
                                  staticClass:
                                    "add-to-calendar-carousel__wrapper",
                                },
                                [
                                  _vm.isMultiRoomReservation
                                    ? _c(
                                        "div",
                                        {
                                          staticClass:
                                            "add-to-calendar-carousel__room",
                                        },
                                        [
                                          _c(
                                            "p",
                                            {
                                              staticClass:
                                                "add-to-calendar-carousel__room -name",
                                            },
                                            [
                                              _vm._v(
                                                "\n              " +
                                                  _vm._s(
                                                    _vm.ModifyReservationRoomTitle
                                                  ) +
                                                  " " +
                                                  _vm._s(item.roomNumberOrder) +
                                                  ": " +
                                                  _vm._s(
                                                    _vm.selectedRes.roomStays[0]
                                                      .roomName
                                                  ) +
                                                  "\n            "
                                              ),
                                            ]
                                          ),
                                          _vm._v(" "),
                                          _c(
                                            "span",
                                            {
                                              staticClass:
                                                "add-to-calendar-carousel__room -confirmation",
                                            },
                                            [
                                              _vm._v(
                                                "Confirmation # " +
                                                  _vm._s(_vm.selectedRes.id)
                                              ),
                                            ]
                                          ),
                                        ]
                                      )
                                    : _vm._e(),
                                  _vm._v(" "),
                                  _c("add-to-calendar", {
                                    attrs: {
                                      "calendar-event-data":
                                        _vm.calendarEventData,
                                      "styles-url": _vm.stylesUrl,
                                    },
                                  }),
                                  _vm._v(" "),
                                  _c(
                                    "div",
                                    {
                                      staticClass:
                                        "add-to-calendar-carousel__navigation",
                                    },
                                    [
                                      _vm.isMultiRoomReservation
                                        ? _c(
                                            "button",
                                            {
                                              staticClass: "switch -prev",
                                              attrs: { disabled: index === 0 },
                                              on: {
                                                click: function ($event) {
                                                  return _vm.arrowClick(
                                                    index - 1
                                                  )
                                                },
                                              },
                                            },
                                            [
                                              _c("em", {
                                                staticClass:
                                                  "icon-chevron-left",
                                              }),
                                            ]
                                          )
                                        : _vm._e(),
                                      _vm._v(" "),
                                      _vm.isMultiRoomReservation
                                        ? _c(
                                            "button",
                                            {
                                              staticClass: "switch -next",
                                              attrs: {
                                                disabled:
                                                  index === _vm.RoomsLeft,
                                              },
                                              on: {
                                                click: function ($event) {
                                                  return _vm.arrowClick(
                                                    index + 1
                                                  )
                                                },
                                              },
                                            },
                                            [
                                              _c("em", {
                                                staticClass:
                                                  "icon-chevron-right",
                                              }),
                                            ]
                                          )
                                        : _vm._e(),
                                    ]
                                  ),
                                ],
                                1
                              )
                            : _vm._e(),
                        ]
                      )
                    }
                  ),
                  _vm._v(" "),
                  _vm.loadingRooms && _vm.isMultiRoomReservation
                    ? _c(
                        "div",
                        { staticClass: "add-to-calendar-carousel__loading" },
                        [_c("loading-dots")],
                        1
                      )
                    : _vm._e(),
                ],
                2
              ),
            ]
          },
        },
      ],
      null,
      true
    ),
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }